import type { RefObject } from "preact";
import type { MediaInfo } from "../api";
import { CloseIcon, PlayIcon } from "./icons";

interface Props {
  videoRef: RefObject<HTMLVideoElement>;
  media: MediaInfo | undefined;
  listening: boolean;
  /** Browser refused autoplay with sound: show a tap-to-start overlay. */
  needsTap: boolean;
  onTap: () => void;
  onCloseMedia: () => void;
  children?: preact.ComponentChildren; // overlay cards
}

/** Avatar full-size by default; with media the media fills the stage and the avatar docks as a small picture-in-picture. */
export function Stage({ videoRef, media, listening, needsTap, onTap, onCloseMedia, children }: Props) {
  return (
    <div class={`wk-stage${media ? " wk-media" : ""}`}>
      <div class="wk-pane">
        {media?.kind === "image" && <img key={media.id} src={media.url} alt={media.label} />}
        {media?.kind === "video" && <video key={media.id} src={media.url} controls autoplay muted playsInline />}
        {media && (
          <button class="wk-close" onClick={onCloseMedia} aria-label="Close media" title="Close">
            <CloseIcon />
          </button>
        )}
        {media && <span class="wk-caption">{media.label}</span>}
      </div>
      <div class="wk-avatar">
        <video ref={videoRef} autoplay playsInline disablePictureInPicture />
        <span class={`wk-ring${listening ? " on" : ""}`} aria-hidden="true" />
      </div>
      {needsTap && (
        <button class="wk-tap" onClick={onTap} aria-label="Tap to start video">
          <span><PlayIcon /> Tap to start video</span>
        </button>
      )}
      {children}
    </div>
  );
}
